import styled from 'styled-components';
import { breakpoints } from 'config/config';

export const ProgressBarFill = styled('div')<{ $width: number }>`
  height: 100%;
  background-color: ${({ theme }) => theme.goldenYellow};
  transition: width 0.3s ease;
  width: ${({ $width }) => $width}%;
`;

export const StyledPublicationPeriod = styled('div')`
  display: flex;
  align-items: baseline;

  .dates-label {
    font-size: 14px;
    font-weight: 500;
    color: ${({ theme }) => theme.grey};
    flex: 0 0 15%;
  }

  .dates-content {
    flex: 0 0 85%;
    display: flex;
    align-items: center;
    gap: 25px;

    .date-start {
      font-size: 14px;
      color: ${({ theme }) => theme.colorText};
      white-space: nowrap;
      font-weight: 600;
    }

    .date-row {
      font-size: 14px;
      color: ${({ theme }) => theme.colorText};
      white-space: nowrap;

      .date-label {
        padding-right: 15px;
        color: ${({ theme }) => theme.grey};
      }

      .date-value {
        font-weight: 600;
      }
    }

    .progress-bar-container {
      flex: 1;
      min-width: 100px;

      .progress-bar-background {
        height: 6px;
        background-color: ${({ theme }) => theme.mediumGray};
        border-radius: 4px;
        overflow: hidden;

      }
    }
  }

  @media only screen and (max-width: ${breakpoints.lg}px) {
    display: grid;
    grid-template-columns: auto 1fr;
    align-items: center;
    padding: 12px 0;
    row-gap: 8px;

    .dates-label {
      flex: none;
      grid-column: 1;
      grid-row: 1;
      font-size: 16px;
    }

    .dates-content {
      display: contents;

      .date-start {
        grid-column: 2;
        grid-row: 1;
        text-align: right;
        font-size: 16px;
      }

      .progress-bar-container {
        grid-column: 1 / -1;
        grid-row: 2;
        width: 100%;
        min-width: unset;
      }

      .date-row {
        grid-column: 1 / -1;
        grid-row: 3;
        display: flex;
        justify-content: space-between;

        .date-label {
          padding-right: 0;
          font-weight: 500;
          font-size: 16px;
        }

        .date-value {
          font-size: 16px;
        }
      }
    }
  }
`;